
// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import User from './User/User'
import template from './modules/template'
import information from './modules/information'
import navigation from './modules/navigation' // 导入导航模块

const store = new Vuex.Store({
  modules: {
    User,
    template,
    information,
    navigation // 注册导航模块
  },
})

export default store
